import type { Bed } from './beds'

/** Confirmed by Bliss: both guardrails and outside corner boards are ¾″ stock. */
export const BUNK_BOARD_THICKNESS = 0.75
export const BUNK_CORNER_FACE = 3.5

type Frame = { x: number; width: number }

/** Outside L-shaped supports back the rails; neither layer enters the mattress pocket. */
export function bunkJoinery(b: Bed) {
  const thickness = BUNK_BOARD_THICKNESS,
    ladderDepth = 3
  const frameLength = b.depth - ladderDepth
  // Keep the established planning footprint. Its width includes a 1″ allowance
  // on each side of the carcass; ½″ mattress clearance is kept inside each rail.
  const lower: Frame = { x: 1, width: b.width - 2 }
  // Catalog labels are title-cased; older saved plans use lowercase lower sizes.
  const name = b.name.toLowerCase()
  const offset =
    (name === 'twin over full' || name === 'twin xl over queen') && lower.width > 42
  const upper: Frame = { x: lower.x, width: offset ? Math.min(lower.width, 42) : lower.width }
  const pocket = (frame: Frame) => ({
    x: frame.x + 2 * thickness,
    z: 2 * thickness,
    width: frame.width - 4 * thickness,
    length: frameLength - 4 * thickness,
  })
  const top = pocket(upper),
    entryWidth = Math.min(20, top.width * 0.65)
  const entryX = offset ? top.x + top.width - entryWidth : top.x + (top.width - entryWidth) / 2
  return { thickness, ladderDepth, frameLength, lower, upper, pocket, offset, entryX, entryWidth }
}

